import Vue from 'vue'
import Router from 'vue-router'

import firebase from 'firebase/app'
import 'firebase/auth'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      // =============================================================================
      // MAIN LAYOUT ROUTES
      // =============================================================================
      path: '',
      component: () => import('./layouts/main/Main.vue'),
      children: [
        // =============================================================================
        // Theme Routes
        // =============================================================================
        {
          path: '/',
          redirect: '/dashboard',
        },
        {
          path: '/dashboard',
          name: 'Dashboard',
          component: () => import('./views/Dashboard/Main.vue'),
          meta: {
            authRequired: true,
            rule: 'editor',
          },
        },
        {
          path: '/install/:key',
          name: 'Install',
          component: () => import('./views/install/Install.vue'),
          meta: {
            authRequired: true,
            rule: 'editor',
          },
        },
        {
          path: '/connect/:key',
          name: 'Connect',
          component: () => import('./views/install/Connect.vue'),
          meta: {
            authRequired: true,
            rule: 'editor',
          },
        },
        {
          path: '/database/automations/',
          name: 'Automations',
          component: () => import('@/views/Automations/Automations.vue'),
          meta: {
            authRequired: true,
            breadcrumb: [{ title: 'Home', url: '/' }, { title: 'Automation' }, { title: 'Database', active: true }],
            pageTitle: 'Automations',
            rule: 'editor',
          },
        },
        {
          path: '/database/automations/:route/:key',
          name: 'automation-view',
          component: () => import('@/views/Automations/AutomationView.vue'),
          meta: {
            authRequired: true,
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Automation', url: '/database/automations/' },
              { title: 'Details', active: true },
            ],
            pageTitle: 'Automation View',
            rule: 'editor',
          },
        },
        {
          path: '/database/endpoints',
          name: 'Endpoints',
          component: () => import('@/views/Automations/Endpoints.vue'),
          meta: {
            authRequired: true,
            breadcrumb: [{ title: 'Home', url: '/' }, { title: 'Automation' }, { title: 'Endpoints', active: true }],
            pageTitle: 'Endpoints',
            rule: 'editor',
          },
        },
        {
          path: '/Extensions/DataMigration',
          name: 'Data Migration',
          component: () => import('./views/Extensions/DataMigration.vue'),
          meta: {
            authRequired: true,
            rule: 'editor',
          },
        },
        {
          path: '/Extensions/convert',
          name: 'Convert',
          component: () => import('./views/Extensions/Convert.vue'),
          meta: {
            authRequired: true,
            rule: 'editor',
          },
        },
        {
          path: '/settings',
          name: 'Settings',
          component: () => import('./views/User/Settings.vue'),
          meta: {
            authRequired: true,
            breadcrumb: [{ title: 'Home', url: '/' }, { title: 'User' }, { title: 'Settings', active: true }],
            pageTitle: 'Settings',
            rule: 'editor',
          },
        },
        {
          path: '/pricing',
          name: 'Pricing',
          component: () => import('./views/PricingSection/Pricing.vue'),
          props: true,
          meta: {
            authRequired: true,
            rule: 'editor',
          },
        },
        {
          path: '/userActions',
          name: 'page-coming-soon',
          component: () => import('@/views/pages/userActions.vue'),
          meta: {
            authRequired: false,
            userRequired: false,
            rule: 'editor',
          },
        },
        {
          path: '/notifications',
          name: 'Notifications',
          component: () => import('./views/User/chat/Notifications.vue'),
          meta: {
            authRequired: [
              { title: 'System', url: '/' },
              { title: 'Notifications', active: true },
            ],
            pageTitle: 'All Notifications',
            rule: 'editor',
          },
        },

        // =============================================================================
        // Application Routes
        // =============================================================================

        {
          path: '/apps/eCommerce/shop',
          name: 'ecommerce-shop',
          component: () => import('./views/apps/eCommerce/ECommerceShop.vue'),
          meta: {
            authRequired: true,
            breadcrumb: [{ title: 'Home', url: '/' }, { title: 'eCommerce' }, { title: 'Shop', active: true }],
            pageTitle: 'Shop',
            rule: 'editor',
          },
        },
        {
          path: '/apps/eCommerce/wish-list',
          name: 'ecommerce-wish-list',
          component: () => import('./views/apps/eCommerce/ECommerceWishList.vue'),
          meta: {
            authRequired: true,
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'eCommerce', url: '/apps/eCommerce/shop' },
              { title: 'Wish List', active: true },
            ],
            pageTitle: 'Wish List',
            rule: 'editor',
          },
        },
        {
          path: '/apps/eCommerce/checkout',
          name: 'ecommerce-checkout',
          component: () => import('./views/apps/eCommerce/ECommerceCheckout.vue'),
          meta: {
            authRequired: true,
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'eCommerce', url: '/apps/eCommerce/shop' },
              { title: 'Checkout', active: true },
            ],
            pageTitle: 'Checkout',
            rule: 'editor',
          },
        },
        /*
                  Below route is for demo purpose
                  You can use this route in your app
                    {
                        path: '/apps/eCommerce/item/',
                        name: 'ecommerce-item-detail-view',
                        redirect: '/apps/eCommerce/shop',
                    }
                */
        {
          path: '/apps/eCommerce/item/',
          redirect: '/apps/eCommerce/item/5546604',
        },
        {
          path: '/apps/eCommerce/item/:item_id',
          name: 'ecommerce-item-detail-view',
          component: () => import('./views/apps/eCommerce/ECommerceItemDetailView.vue'),
          meta: {
            authRequired: true,
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'eCommerce' },
              { title: 'Shop', url: { name: 'ecommerce-shop' } },
              { title: 'Item Details', active: true },
            ],
            parent: 'ecommerce-item-detail-view',
            pageTitle: 'Item Details',
            rule: 'editor',
          },
        },
        {
          path: '/apps/user/user-edit/:userId',
          name: 'app-user-edit',
          component: () => import('@/views/apps/user/user-edit/UserEdit.vue'),
          meta: {
            authRequired: true,
            breadcrumb: [{ title: 'Home', url: '/' }, { title: 'User' }, { title: 'Edit', active: true }],
            pageTitle: 'User Edit',
            rule: 'editor',
          },
        },

        // =============================================================================
        // Pages Routes
        // =============================================================================

        {
          path: '/user/user-settings',
          name: 'User-user-settings',
          component: () => import('@/views/User/user-settings/UserSettings.vue'),
          meta: {
            authRequired: true,
            breadcrumb: [{ title: 'Home', url: '/' }, { title: 'User' }, { title: 'User Settings', active: true }],
            pageTitle: 'Settings',
            rule: 'editor',
          },
        },
        {
          path: '/pages/knowledge-base',
          name: 'page-knowledge-base',
          component: () => import('@/views/pages/KnowledgeBase.vue'),
          meta: {
            authRequired: true,
            rule: 'editor',
          },
        },

        /*******************************************************/
        // DOCUMENTATION
        /*******************************************************/
        // Universal Docs [CATEGORY] Viewer
        {
          path: '/docs/:catmain',
          name: 'documentationCategoryViewer',
          component: () => import('@/views/docs/documentationCategoryViewer.vue'),
          meta: {
            authRequired: true,
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Documentation', url: '/pages/knowledge-base' },
              { title: 'Category', active: true },
            ],
            parent: 'page-knowledge-base',
            rule: 'editor',
          },
        },

        // Universal Docs [ITEM] Viewer
        {
          path: '/docs/:maincat/:subcat/:subcatItem',
          name: 'page-knowledge-base-category-question',
          props: true,
          component: () => import('@/views/docs/documentationItemViewer.vue'),
          meta: {
            authRequired: true,
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Documentation', url: '/pages/knowledge-base' },
              { title: 'Document', active: true },
            ],
            parent: 'page-knowledge-base',
            rule: 'editor',
          },
        },
        // =============================================================================
        // EXTENSIONS
        // =============================================================================
        {
          path: '/extensions/i18n',
          name: 'extra-component-i18n',
          component: () => import('@/views/components/extra-components/I18n.vue'),
          meta: {
            authRequired: true,
            breadcrumb: [{ title: 'Home', url: '/' }, { title: 'Extensions' }, { title: 'I18n', active: true }],
            pageTitle: 'I18n',
            rule: 'editor',
          },
        },
      ],
    },
    // =============================================================================
    // FULL PAGE LAYOUTS
    // =============================================================================
    {
      path: '',
      component: () => import('@/layouts/full-page/FullPage.vue'),
      children: [
        // =============================================================================
        // PAGES
        // =============================================================================

        {
          path: '/login',
          name: 'Login',
          component: () => import('@/views/login/Login.vue'),
          meta: {
            rule: 'editor',
          },
        },
        {
          path: '/forgot-password',
          name: 'page-forgot-password',
          component: () => import('@/views/pages/ForgotPassword.vue'),
          meta: {
            authRequired: false,
            userRequired: false,
            rule: 'editor',
          },
        },
        {
          path: '/reset-password',
          name: 'page-reset-password',
          component: () => import('@/views/pages/ResetPassword.vue'),
          props: true,
          meta: {
            authRequired: false,
            userRequired: false,
            rule: 'editor',
          },
        },
        {
          path: '/pages/error-404',
          name: 'page-error-404',
          component: () => import('@/views/pages/Error404.vue'),
          meta: {
            authRequired: false,
            userRequired: false,
            rule: 'editor',
          },
        },
        {
          path: '/google-api-services-disclosure',
          name: 'google-api-services-disclosure',
          component: () => import('@/views/pages/googleApiDisclosure.vue'),
          meta: {
            authRequired: false,
            userRequired: false,
            rule: 'editor',
          },
        },
      ],
    },
    // Redirect to 404 page, if no match found
    {
      path: '*',
      redirect: '/pages/error-404',
    },
  ],
})

router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
})

router.beforeEach((to, from, next) => {
  firebase.auth().onAuthStateChanged(() => {
    // Get firebase current user
    const firebaseCurrentUser = firebase.auth().currentUser

    // If current page is Login & the user is already logged in, redirect to root path
    if (to.name === 'Login' && firebaseCurrentUser !== null) {
      next({ path: '/', query: to.query })
    }

    /**
     * If auth required, check login. If login fails redirect to login page.
     * Assign current url as returnUrl query.
     */
    if (to.meta.authRequired) {
      if (!firebaseCurrentUser && to.meta.cu !== false) {
        router.push({ path: '/login', query: { returnUrl: window.location.origin } })
      }
    }

    return next()
  })
})

export default router
